import { useEffect, useState } from 'react'
import { customerData } from '../../utilities/CustomerData'
import { apiURL } from '../../utilities/URLs'
import BlueInkEmbed from '@blueink360/blueink-embed-js'
import { refreshAccessToken } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export default function SignAffidavit() {
  const navigate = useNavigate()
  const [eSignStep, setESignStep] = useState(0)
  const [embedUrl, setEmbedUrl] = useState('')
  const [uploadingDoc, setUploadingDoc] = useState(false)

  const embed = new BlueInkEmbed(process.env.REACT_APP_BLUEINK_PUBLIC_API_KEY)

  embed.on(BlueInkEmbed.EVENT.COMPLETE, async () => {
    await handleESignComplete()
  })

  useEffect(() => {
    const handleGetEmbedURL = async () => {
      const form = new FormData()
      form.append('embedInfo', JSON.stringify({
        leadContact: customerData.customerLeadData.leadContact,
        advanceFundingApplication: customerData.customerAdvanceFunding
      }))

      const embedUrlResponse = await fetch(`${apiURL}/api/getAffidavitEmbedURL`, {
        method: 'POST',
        headers: {
          'Authorization': customerData.accessToken
        },
        body: form
      })
      const embedUrlData = await embedUrlResponse.json()
      if(embedUrlData.response.error) {
        if(embedUrlData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetEmbedURL() : navigate('/', { state: { expired: true } })
        } else if(embedUrlData.response.error === 'No IDme Attributes.')
          navigate('/resyncIDme') 
          else 
          console.error(embedUrlData.response.error)
      } else
        setEmbedUrl(embedUrlData.response.embedUrl)
    }

    handleGetEmbedURL()
  }, [])

  useEffect(() => {
    if (embedUrl)
      embed.mount(embedUrl, '#iframe-container', { height: '1000px' })
  }, [embedUrl])

  const handleESignComplete = async () => {
    setUploadingDoc(true)

    const eSignCompleteResponse = await fetch(`${apiURL}/api/completeESign?leadId=${encodeURIComponent(customerData.customerLeadData.leadId)}&isIssue=1`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const eSignCompleteData = await eSignCompleteResponse.json()
    setUploadingDoc(false)
    if(eSignCompleteData.response.error) {
      if(eSignCompleteData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleESignComplete() : navigate('/', { state: { expired: true } })
      } else
        console.error(eSignCompleteData.response.error)
    } else {
      setESignStep(eSignStep+1)
      customerData.updateCustomerStage('25f7468c-f94f-4f19-aba3-8050a2661980', 'd23bdf4e-886f-493a-b628-8c9a1efb398b', 'Issue Resolved')
      navigate('/')
    }
  }

  return (
    <div className={`flex flex-col items-center lg:p-10 lg:w-screen w-11/12`}>
      <div className='w-full flex flex-col items-center justify-center gap-4'>
        <p className='text-2xl font-bold'>Affidavit Signature</p>
        {embedUrl ? (
          <div className='w-full h-full flex flex-1 flex-col items-center gap-4'>
            <div className='lg:w-1/2 w-11/12 h-[70vh]' id='iframe-container'></div>
            {uploadingDoc && (
              <div className='flex flex-row items-center justify-center gap-2'>
                <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
                <p>Completing E-Sign...</p>
              </div>
            )}
          </div>
        ) : (
          <div className='flex flex-row items-center justify-center gap-2'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
            <p>Loading...</p>
          </div>
        )}
      </div>
    </div>
  )
}